import { Wifi, Plus, Trash2 } from "lucide-react";
import { inputCls, labelCls } from "./constants";

export default function MiPlansSection({ miPlans, setMiPlans, updateMi, addMi }) {
  return (
    <section>
      <div className="flex items-center justify-between mb-4">
        <h3 className="flex items-center gap-2 font-bold text-slate-800 text-lg">
          <Wifi size={18} className="text-[#1f3a8a]" /> Internet mobilny
        </h3>
        <button data-testid="add-mi-plan" onClick={addMi} className="inline-flex items-center gap-1 text-sm font-semibold text-[#1f3a8a] hover:text-[#15296b]">
          <Plus size={16} /> Dodaj pakiet
        </button>
      </div>
      <div className="grid sm:grid-cols-3 gap-4">
        {miPlans.map((p, i) => (
          <div key={i} data-testid={`mi-plan-${i}`} className="rounded-xl border border-slate-200 p-4 bg-slate-50/50 space-y-3">
            <div className="flex items-center justify-between">
              <span className="text-xs font-mono text-slate-400">{p.id}</span>
              <button onClick={() => setMiPlans((prev) => prev.filter((_, idx) => idx !== i))} className="text-red-500 hover:text-red-700"><Trash2 size={15} /></button>
            </div>
            <div>
              <label className={labelCls}>Nazwa</label>
              <input data-testid={`mi-name-${i}`} className={inputCls} value={p.name} onChange={(e) => updateMi(i, "name", e.target.value)} />
            </div>
            <div>
              <label className={labelCls}>Etykieta obok ikony WiFi (opcjonalne)</label>
              <div className="grid grid-cols-3 gap-2">
                <input
                  data-testid={`mi-icon-label-${i}`}
                  className={`${inputCls} col-span-2`}
                  value={p.icon_label || ""}
                  onChange={(e) => updateMi(i, "icon_label", e.target.value)}
                  placeholder="np. 5G, Router, Home"
                />
                <select
                  data-testid={`mi-icon-label-size-${i}`}
                  className={inputCls}
                  value={p.icon_label_size || "md"}
                  onChange={(e) => updateMi(i, "icon_label_size", e.target.value)}
                  title="Rozmiar etykiety"
                >
                  <option value="sm">Mała (S)</option>
                  <option value="md">Średnia (M)</option>
                  <option value="lg">Duża (L)</option>
                  <option value="xl">Bardzo duża (XL)</option>
                </select>
              </div>
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className={labelCls}>Cena (zł)</label>
                <input data-testid={`mi-price-${i}`} type="number" className={inputCls} value={p.price} onChange={(e) => updateMi(i, "price", e.target.value)} />
              </div>
              <div>
                <label className={labelCls}>Okres</label>
                <input className={inputCls} value={p.period} onChange={(e) => updateMi(i, "period", e.target.value)} />
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
